import { CalendarClock, CalendarRange, Repeat, Sun, Calendar } from 'lucide-react';
import { ScheduleRuleType } from '../../../utils/scheduleRuleConstants';

export function getRuleIcon(type: number | undefined, className = 'w-4 h-4') {
  switch (type) {
    case ScheduleRuleType.Weekly: return <Repeat className={className} />;
    case ScheduleRuleType.BiWeekly: return <CalendarRange className={className} />;
    case ScheduleRuleType.Monthly: return <CalendarClock className={className} />;
    case ScheduleRuleType.Seasonal: return <Sun className={className} />;
    default: return <Calendar className={className} />;
  }
}

export function getRuleBadgeVariant(type: number | undefined): 'info' | 'success' | 'warning' | 'default' {
  switch (type) {
    case ScheduleRuleType.Weekly: return 'success';
    case ScheduleRuleType.BiWeekly: return 'info';
    case ScheduleRuleType.Monthly: return 'warning';
    case ScheduleRuleType.Seasonal: return 'default';
    default: return 'default';
  }
}
